<template>
  <div class="card h-100 justify-content-start" :class="{ selected: showSelectionBorder }">
    <div class="p-2">
      <!--    Header    -->
      <div class="mb-2">
        <div class="d-flex align-items-center">
          <template v-if="showLockColumn">
            <span
              v-if="isLocked"
              class="material-icons lock-icon md-18 me-1 mb-1 text-danger"
              aria-hidden="true"
              :title="lockedBy"
              >lock</span
            >
            <span v-else class="material-icons lock-icon md-18 me-1 mb-1" aria-hidden="true">lock_open</span>
          </template>
          <template v-if="showSelectionColumn">
            <el-checkbox v-model="selectedRow" />
            <span v-if="selectedRow" class="ps-2 text-uppercase">{{ $i18n.t('card_selected') }}</span>
          </template>
        </div>
      </div>
      <!--  Content  -->
      <div class="card-content d-flex flex-wrap">
        <div v-for="(column, index) in columns" :key="index" class="field-container col-12 col-sm-6 col-md-12 col-lg-6">
          <div class="field-border h-100 p-3">
            <div class="fw-bold mb-3">{{ $i18n.t(column.title) }}</div>
            <field-wrapper :row="listData[rowIndex]" :field-name="column.data" />
          </div>
        </div>
      </div>
    </div>
    <action-button-container v-if="showActionButtons" :row-index="rowIndex" />
  </div>
</template>

<script>
import ActionButtonContainer from '../ActionButtonContainer'
import FieldWrapper from '../../field-types/FieldWrapper'
import { get, xor } from 'lodash'

export default {
  name: 'CardView',
  components: {
    ActionButtonContainer,
    FieldWrapper,
  },
  props: {
    rowId: {
      type: [Number, String],
    },
    rowIndex: {
      type: Number,
    },
    recordLock: {
      type: Object,
    },
  },
  computed: {
    columns() {
      return this.$get('columns')
    },
    extendedOptions() {
      return this.$get('extendedOptions')
    },
    listData() {
      return this.$get('listData')
    },
    lockedBy() {
      return get(this.recordLock, 'userName', this.$i18n.t('unknown_user'))
    },
    isLocked() {
      return get(this.recordLock, 'isLocked', false)
    },
    selectedRow: {
      get() {
        return this.$get('selectedRows').includes(this.rowId)
      },
      set() {
        const value = xor(this.$get('selectedRows'), [this.rowId])
        this.$dispatch('setSelectedRows', { value })
      },
    },
    showActionButtons() {
      return this.visibilityState({ key: 'showActionButtons' })
    },
    showLockColumn() {
      return get(this.extendedOptions, 'showLockColumn', false)
    },
    showSelectionColumn() {
      return this.visibilityState({ key: 'showSelectionColumn' })
    },
    showSelectionBorder() {
      return this.selectedRow && (this.listData.length > 1 || this.showSelectionColumn)
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
  methods: {
    handleSelectionChange(rows) {
      this.selectedRows = rows.map((row) => row.ROW_KEY)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid $border-color;
  border-radius: $border-radius;
  &.selected {
    border-color: $default-font-color;
    box-shadow: 0 0 5px #270e66;
  }
}
.field-container {
  margin-top: -1px;
}
.field-border {
  border: 1px solid $border-color;
}
@media (min-width: 576px) and (max-width: 768px) {
  .field-container:nth-child(odd) {
    padding-inline-end: 0.5rem;
  }
}
@media (min-width: 992px) {
  .field-container:nth-child(odd) {
    padding-inline-end: 0.5rem;
  }
}
</style>
